import { render } from "./ExerciseModule.vue?vue&type=template&id=06321a5f&scoped=true&ts=true"
import script from "./ExerciseModule.vue?vue&type=script&lang=ts"
export * from "./ExerciseModule.vue?vue&type=script&lang=ts"

import "./ExerciseModule.vue?vue&type=style&index=0&id=06321a5f&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06321a5f"]])

export default __exports__